import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '@/helpers/user.helper.js';

const API_URL = process.env.VUE_APP_API_URL + 'driver/';

class DriverService {

    getClientDrivers() {
        return axios.get(API_URL + 'getlist/' + UserHelper.getClientId(), {
            headers: authHeader()
        });
    }

    getDriver(id) {
        return axios.get(API_URL + 'get/' + id, {
            headers: authHeader()
        });
    }

    createDriver(data) {
        return axios.post(API_URL + 'create/' + UserHelper.getClientId(), data, {
            headers: authHeader()
        });
    }

    updateDriver(id, data) {
        return axios.put(API_URL + 'update/' + id, data, {
            headers: authHeader()
        });
    }

    deleteDriver(id) {
        return axios.delete(API_URL + 'delete/' + id, {
            headers: authHeader()
        });
    }

    getDriverBadges(driverId) {
        return axios.get(API_URL + driverId + '/badges', {
            headers: authHeader()
        });
    }

    addDriverBadge(driverId, badgeId) {
        return axios.put(API_URL + driverId + '/badges/' + badgeId, {}, {
            headers: authHeader()
        });
    }

    removeDriverBadge(driverId, badgeId) {
        return axios.delete(API_URL + driverId + '/badges/' + badgeId, {
            headers: authHeader()
        });
    }
}

export default new DriverService();